var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveVipMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.386,
    height: 17.603,
    viewBox: "0 0 139.386 17.603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p8iiicoata",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a243f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5i8u7z3f7b",
    x1: 1.152,
    y1: 0.231,
    x2: 0,
    y2: 0.232,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d8d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4c4c4"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10626"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10625"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46872",
    d: "M.17 0h2.779l.875-5.165A1.511 1.511 0 0 1 5.273-6.58c.727 0 1.119.5 1 1.312L5.381 0h2.676l.881-5.21a1.444 1.444 0 0 1 1.431-1.37c.71 0 1.131.472 1.006 1.341L10.489 0h2.773l.977-5.875c.313-1.841-.648-2.966-2.284-2.966a3.178 3.178 0 0 0-2.92 1.716h-.092a1.874 1.874 0 0 0-2.091-1.716A3.023 3.023 0 0 0 4.1-7.125H4l.261-1.6H1.625zm18.858.165a4.547 4.547 0 0 0 4.585-2.824l-2.533-.074a1.814 1.814 0 0 1-1.665.892c-1.085 0-1.608-.642-1.432-1.75l.017-.1h5.812l.108-.693c.477-2.869-1-4.455-3.477-4.455a5.082 5.082 0 0 0-5.08 4.511C14.892-1.54 16.29.165 19.028.165zM18.3-5.307a1.983 1.983 0 0 1 1.892-1.528 1.233 1.233 0 0 1 1.3 1.528zM24.636 0h2.778l.875-5.165a1.511 1.511 0 0 1 1.45-1.415c.727 0 1.119.5 1 1.312L29.847 0h2.676l.877-5.21a1.444 1.444 0 0 1 1.435-1.37c.71 0 1.131.472 1.006 1.341L34.955 0h2.773l.972-5.875c.313-1.841-.648-2.966-2.284-2.966A3.178 3.178 0 0 0 33.5-7.125h-.091a1.874 1.874 0 0 0-2.091-1.716 3.023 3.023 0 0 0-2.75 1.716h-.1l.261-1.6h-2.638zm14.8 0h2.75l.227-1.415h.108A2.049 2.049 0 0 0 44.7.125c1.932 0 3.75-1.511 4.239-4.483.511-3.08-.9-4.483-2.722-4.483a3.1 3.1 0 0 0-2.739 1.608h-.057l.722-4.4h-2.774zm3.449-4.364c.227-1.426.972-2.307 1.989-2.307 1.034 0 1.443.9 1.216 2.307s-.954 2.324-1.976 2.324-1.455-.909-1.228-2.324zM53.733.165a4.547 4.547 0 0 0 4.585-2.824l-2.534-.074a1.814 1.814 0 0 1-1.665.892c-1.085 0-1.608-.642-1.432-1.75l.017-.1h5.812l.108-.693c.477-2.869-1-4.455-3.477-4.455a5.082 5.082 0 0 0-5.08 4.511C49.6-1.54 50.994.165 53.733.165zM53-5.307a1.983 1.983 0 0 1 1.892-1.528 1.233 1.233 0 0 1 1.3 1.528zM59.324 0H62.1l.784-4.739A2.049 2.049 0 0 1 64.9-6.477a3.634 3.634 0 0 1 1.074.148l.409-2.42a3.285 3.285 0 0 0-.761-.1A2.538 2.538 0 0 0 63.3-7.136h-.09l.267-1.591h-2.7z",
    transform: "translate(73 17)",
    style: {
      fill: "#0a243f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10545"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46171",
    d: "M6.474-11.636H1.568l2.625 16h5.938l7.937-16h-4.906L8.006-.355h-.125zm17.469 0H19.6l-2.656 16h4.344zm-.594 16h4.344l.8-4.75h2.391c3.688 0 6.469-2.125 7.031-5.594.563-3.406-1.437-5.656-5-5.656h-6.909zm5.7-8.125.734-4.406h1.531c1.531 0 2.281.812 2.063 2.187a2.593 2.593 0 0 1-2.813 2.219z",
    transform: "translate(31 12.636)",
    style: {
      fill: "url(#p8iiicoata)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10028"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46172",
    d: "M133.7 272.818h-7.318a4.71 4.71 0 0 1-.532-.031 1.454 1.454 0 0 1-1.35-1.187l-1.1-4.238c-.547-2.111-1.1-4.22-1.641-6.332a1.469 1.469 0 0 1 1.143-1.889 1.521 1.521 0 0 1 .847.1q2.146.826 4.291 1.656c.392.152.415.15.679-.189q1.883-2.418 3.763-4.838a1.456 1.456 0 0 1 2.421-.012q1.9 2.434 3.8 4.874c.237.3.261.313.615.176 1.422-.549 2.846-1.094 4.266-1.65a1.5 1.5 0 0 1 2.052 1.811q-1.373 5.283-2.742 10.566a1.522 1.522 0 0 1-1.65 1.183H133.7z",
    style: {
      fill: "url(#5i8u7z3f7b)"
    },
    transform: "translate(-121.705 -255.218)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveVipMemberIcon);
export default __webpack_public_path__ + "static/media/inactiveVipMemberIcon.6c831ad4fc689761a0c32853225fb043.svg";
export { ForwardRef as ReactComponent };